import React, { useState } from 'react';
import { Box, Button, VStack, Heading, Span, Text, HStack } from '@bpba/ui-components';
import { useMutation } from '@apollo/client';
import { Mutations } from '../rest/Mutations';
import { SpinnerCajas } from '../pages/Spinner/SpinnerCajas';
import { SubmitHandler, useFieldArray, useForm } from 'react-hook-form';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { DemandaColectivaIFEModel } from '../rest/models/DemandaColectivaIFEModel';
import { DemandaColectivaIFEModelRQ } from '../rest/models/DemandaColectivaIFEModelRQ';
import { EsClienteDemandaIFERQ } from '../rest/models/EsClienteDemandaIFERQ';
import { postDemandaIFE } from '../rest/mutations/postDemandaIFE';
import { postEsClienteDemandaIFE } from '../rest/mutations/postEsClienteDemandaIFE';
import { InformesIFEModel } from '../rest/models/InformesIFEModel';
import CurrencyInput from 'react-currency-input-field';



const DemandaColectivaIFEComponente: React.FC = () => {

    
    const { executeRecaptcha } = useGoogleReCaptcha();
    const { register, handleSubmit, reset, control, clearErrors, setValue, getValues, formState: { errors } } = useForm<any>({
        mode: 'onChange',
        criteriaMode: 'all',
        reValidateMode: 'onChange',
        defaultValues: {
            informeIFE: [{
                fechaDebito: null,
                detalle: undefined,
                importe: undefined

            }],
            razonSocial: ''

        }
    });

    const REQUIRED_FIELD = "Campo requerido.";
    /* eslint-disable */
    const mailValidator = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    const numberValidator = /^\d+$/;

    const [postEsClienteDemandaIFEAPI, { loading: loadingEsClienteIFE }] = useMutation<Mutations>(postEsClienteDemandaIFE);
    const [postDemandaIFEAPI, { loading: loadingDemandaIFE }] = useMutation<Mutations>(postDemandaIFE);

    const [internalToken, setInternalToken] = useState<string>("");
    const [nroCuentas, setNroCuentas] = useState<Array<number>>([]);

    const [servicioOk, setServicioOk] = useState<boolean>(false);
    const [infoDebitoIFE, setInfoDebitoIFE] = useState<boolean>(false);
    const [recibeEnCuentaOrigen, setRecibeEnCuentaOrigen] = useState<boolean>(false);
    const [mensajeRtaServicio, setMensajeRtaServicio] = useState<string>("");
    const [cuitValidado, setCuitValidado] = useState<boolean>(false);
    const [showFullForm, toggleFullForm] = useState<boolean>(false);
    const [mensajeErrorPostFinal, setMensajeErrorPostFinal] = useState<string>("");
    const [errorServicio, setErrorServicio] = useState<boolean>(false);
    const [mensajeError, setMensajeError] = useState<React.ReactNode>("");



    const { fields, append, remove } = useFieldArray({
        control,
        name: 'informeIFE'

    });





    const validateRealCuit = (cuit: string) => {
        let rv = false;

        let resultado = 0;
        const codes = "6789456789";
        let verificador = parseInt(cuit[cuit.length - 1]);
        let x = 0;

        while (x < 10) {
            let digitoValidador = parseInt(codes.substring(x, x + 1));
            if (isNaN(digitoValidador)) digitoValidador = 0;
            let digito = parseInt(cuit.substring(x, x + 1));
            if (isNaN(digito)) digito = 0;
            let digitoValidacion = digitoValidador * digito;
            resultado += digitoValidacion;
            x++;
        }
        resultado = resultado % 11;
        rv = resultado === verificador;

        return rv ? rv : "Verifique el Cuit ingresado";
    };
    const ValidarCuit = async (data: DemandaColectivaIFEModel) => {
        const token = executeRecaptcha && (await executeRecaptcha('DemandaColectivaIFE'));

        let datos: EsClienteDemandaIFERQ = {
            "cuit": Number(data.cuit),
            "googleToken": token
        }

        postEsClienteDemandaIFEAPI({ variables: { input: datos } }).then((response: any) => {

            if (response !== null || response !== undefined) {
                if (response.data.EsClienteDemandaIFERQ.resultado.toLocaleUpperCase() != 'error'.toLocaleUpperCase()) {
                    setInternalToken(response.data.EsClienteDemandaIFERQ.mensaje);
                    setNroCuentas(response.data.EsClienteDemandaIFERQ.nroCuentas);
                    toggleFullForm(true);
                    setCuitValidado(true);
                } else {
                    setErrorServicio(true);
                    setMensajeError(response.data.EsClienteDemandaIFERQ.mensaje);
                }
            }


        }).catch((e: any) => {


            setErrorServicio(true);
            setMensajeError("Ha ocurrido un problema, inténtelo mas tarde.");

        });
    }

    const onSubmit: SubmitHandler<DemandaColectivaIFEModel> = async (data: DemandaColectivaIFEModel) => showFullForm ? SubmitForm(data) : ValidarCuit(data)


    const SubmitForm: SubmitHandler<DemandaColectivaIFEModel> = async (data: DemandaColectivaIFEModel) => {

        let arrFormatted: Array<InformesIFEModel> = [];
        data.informeIFE?.forEach((index) => {

            const conceptoFormatted: InformesIFEModel = {
                fechaDebito: index.fechaDebito,
                detalle: Number(index.detalle),
                importe: index.importe

            }

            arrFormatted.push(conceptoFormatted);
        });

        let datos: DemandaColectivaIFEModelRQ = {
            "cuit": Number(data.cuit),
            "nombre": data.razonSocial,
            "email": data.email,
            "telefono": (data.telefonoArea + data.telefono).toString(),
            "token": internalToken,
            "tipoGestion": data.tipoGestion ? Number(data.tipoGestion) : 0,
            "observaciones": data.observaciones,
            "nroCuentaDebitada": data.nroCuentaDebitada ? Number(data.nroCuentaDebitada) : 0,
            "identificacionCuenta": data.identificacionCuenta,
            "conceptos": infoDebitoIFE ? arrFormatted : []
        }
        postDemandaIFEAPI({ variables: { input: datos } }).then((response: any) => {

            if (response !== null || response !== undefined) {

                if (response.data.DemandaColectivaIFEModelRQ.resultado.toLocaleUpperCase() === "ok".toLocaleUpperCase()) {
                    setServicioOk(true);
                    setMensajeRtaServicio("Solicitud creada con éxito. En los próximos días nos contactaremos con vos.");
                } else {

                }
            }

        }).catch((e: any) => {

            setServicioOk(false);
            setMensajeErrorPostFinal("Ha ocurrido un problema, inténtelo mas tarde.");

        });


    }

    const handleReset = () => {
        reset({});
        window.location.reload();
    };
    const tipoGestionInfo = (tipoGestion: string) => {
        setValue("informeIFE", [{
            fechaDebito: null,
            detalle: "",
            importe: undefined

        }]);

        setInfoDebitoIFE(false);
        if (tipoGestion === '0') { setInfoDebitoIFE(true); }


    };

    const addCommas = (num: string) => {
        return num.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    };

    const handleDetalleChange = (detalle: string, detalleAActualizar: string) => {
        setValue(detalleAActualizar, Number(detalle != '' ? detalle : 0));
    };
    const handleImporteDebitoChange = (importeDebito: string, debitoAActualizar: string) => {
        setValue(debitoAActualizar, addCommas(importeDebito));
    };

    const handleCuentaChange = (cuentaElegida: string) => {

        if (infoDebitoIFE && recibeEnCuentaOrigen && cuentaElegida != "") {
            setValue("identificacionCuenta", cuentaElegida)
        }
    };



    if (loadingEsClienteIFE || loadingDemandaIFE) return <SpinnerCajas />;
    if (servicioOk) return (
        <VStack>
            <Text fontSize={"22px"} lineHeight={"27px"} fontWeight={"400"} color={"primary.0"}>{mensajeRtaServicio}</Text>
            <Button
                onClick={() => handleReset()}
                variant="secondary"
                py={"10px !important"}
            >
                Finalizar
            </Button>
        </VStack>
    );
    if (mensajeErrorPostFinal !== "" && !servicioOk) return (
        <VStack>
            <Text fontSize={"22px"} lineHeight={"27px"} fontWeight={"400"} color={"red"}>{mensajeErrorPostFinal}</Text>
            <Button
                onClick={() => handleReset()}
                variant="secondary"
                py={"10px !important"}
            >
                Volver
            </Button>
        </VStack>
    );


    return (
        <Box>
            <VStack>
                <form onSubmit={handleSubmit(onSubmit)}>
                    {!cuitValidado ?

                        (<>
                            <Heading level={3} mb={'2px'} fontWeight={400} tabIndex={0}>
                                Datos Generales
                            </Heading>
                            {errorServicio ?
                                <VStack mt={"20px"}>
                                    <Span color="red" fontSize={"12px"} tabIndex={0}>
                                        {mensajeError}
                                    </Span>
                                </VStack> : <></>
                            }
                            <VStack mt={"20px"}>

                                <input {...register(`cuit`, { required: REQUIRED_FIELD, minLength: { value: 11, message: "Debe tener al menos 11 dígitos" }, pattern: { value: numberValidator, message: "El campo debe ser numérico" } })} maxLength={11} name='cuit' type={"text"} defaultValue={""} placeholder='N° de CUIL/CUIT' />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.cuit ? "* " + errors.cuit.message : ""}</Span>
                            </VStack>
                            <Button type="submit" variant="secondary" py={"10px !important"}>Validar</Button>

                        </>)
                        : (<>
                            <Heading level={3} mb={'2px'} fontWeight={400} tabIndex={0}>
                                Datos Generales
                            </Heading>
                            <VStack mt={"20px"}>

                                <input type={"text"} tabIndex={0}
                                    {...register("cuit", {
                                        required: REQUIRED_FIELD, minLength: { value: 11, message: "cantidad minima de caracteres: 11" },
                                        maxLength: 11, validate: (value) => validateRealCuit(value.toString())
                                    })}
                                    name='cuit' id='cuit' placeholder='CUIT ej: 30123456789' maxLength={11} minLength={11} disabled />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>
                                    {errors.cuit ? "* " + errors.cuit.message : ""}
                                </Span>
                            </VStack>


                            <VStack mt={"20px"}>
                                <input {...register(`razonSocial`, { required: REQUIRED_FIELD, maxLength: 100 })} name='razonSocial' type={"text"} defaultValue={""} placeholder='Nombre y apellido / Razón social' maxLength={100} />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.razonSocial ? "* " + errors.razonSocial.message : ""}</Span>
                            </VStack>
                            <VStack mt={"20px"}>
                                <input type={'text'} {...register("email", { required: REQUIRED_FIELD, pattern: { value: mailValidator, message: "Formato de email inválido ejemplo: juana@mail.com" } })} name="email" placeholder='E-mail' maxLength={100} />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.email ? "* " + errors.email.message : ""}</Span>
                            </VStack>


                            <VStack mt={"20px"}>
                                <Span mb={"8px"} color="primary.0" fontSize={"14px"} style={{ lineHeight: "18px" }}>
                                    Teléfono de contacto
                                </Span>
                                <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                                    <VStack mr={"0.5rem"}>
                                        <input type="text" style={{ width: "100%" }} {...register("telefonoArea", { required: REQUIRED_FIELD, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="telefonoArea" placeholder='Ej.: 11' maxLength={4} />
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.telefonoArea ? "* " + errors.telefonoArea.message : ""}</Span>
                                    </VStack>
                                    <VStack>
                                        <input type="text" tabIndex={0} style={{ width: "100%" }} {...register("telefono", { required: REQUIRED_FIELD, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="telefono" placeholder='Ej.: 4232424' maxLength={14} />
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.telefono ? "* " + errors.telefono.message : ""}</Span>
                                    </VStack>
                                </VStack>
                            </VStack>
                            <VStack mt={"20px"}>
                                <Span mb={"8px"} color="primary.0" fontSize={"14px"} style={{ lineHeight: "18px" }}>
                                    Indique la gestión a realizar
                                </Span>

                                <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                                    <VStack mr={"0.5rem"}>
                                        <select tabIndex={0} aria-label={"Indique la gestión a realizar"}
                                            style={{ width: "100%" }}
                                            {...register("tipoGestion", { required: REQUIRED_FIELD })}
                                            onChange={(e: any) => tipoGestionInfo(e.target.value)} name="tipoGestion" placeholder='Indique la gestión a realizar' >

                                            <option value="1">Solicitud de información de los importes debitados</option>
                                            <option value="0">Solicitud de devolución de los importes debitados sobre acreditaciones IFE</option>
                                        </select>
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.tipoGestion ? "* " + errors.tipoGestion.message : ""}</Span>
                                    </VStack>

                                </VStack>



                            </VStack>
                            <VStack mt={"20px"}>
                                <Span mb={"8px"} color="primary.0" fontSize={"14px"} style={{ lineHeight: "18px" }}>
                                    Observaciones
                                </Span>
                                <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                                    <VStack>
                                        <input type="text" style={{ width: "100%" }} {...register("observaciones", { required: false, maxLength: 255 })} name="observaciones" placeholder='Detalle la información adicional/ observaciones que considere' maxLength={255} />
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.observaciones ? "* " + errors.observaciones.message : ""}</Span>
                                    </VStack>

                                </VStack>
                            </VStack>

                            <VStack mt={"20px"}>

                                <Span mb={"8px"} color="primary.0" fontSize={"14px"} style={{ lineHeight: "18px" }}>
                                    Cuenta donde se imputaron los débitos
                                </Span>
                                <VStack>
                                    <select tabIndex={0} aria-label={"Seleccione la sucursal"}
                                        {...register("nroCuentaDebitada", { required: REQUIRED_FIELD })}
                                        name="nroCuentaDebitada" onChange={(e) => { handleCuentaChange(e.target.value) }}>
                                        <option value="" selected > Seleccione una cuenta </option>
                                        {nroCuentas &&
                                            nroCuentas.map((item: any) =>
                                                <option value={item} key={item}>{item}</option>
                                            )}

                                    </select>
                                    <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.nroCuentaDebitada ? "* " + errors.nroCuentaDebitada.message : ""}</Span>
                                </VStack>




                            </VStack>
                            {infoDebitoIFE ?
                                (
                                    <VStack>
                                        <Span mt={"20px"} color="primary.0" fontSize={"14px"} style={{ lineHeight: "18px" }} tabIndex={0}>
                                            Usted eligió la opción devolución, por lo tanto deberá completar los siguientes datos de forma obligatoria
                                        </Span>
                                        <HStack mt={"20px"}>
                                            <input type='checkbox' tabIndex={0} {...register("recibeEnCuentaOrigen")} name="recibeEnCuentaOrigen" style={{ transform: "scale(1.3)", marginBottom: "2px" }} onChange={(e) => { clearErrors("identificacionCuenta"); setRecibeEnCuentaOrigen(e.target.checked); setValue("recibeEnCuentaOrigen", e.target.checked); e.target.checked ? setValue("identificacionCuenta", getValues("nroCuentaDebitada")) : setValue("identificacionCuenta", undefined) }} />
                                            <Span mt={"5px"} mb={"8px"} ml={"8px"} color="primary.0" fontSize={"14px"} style={{ lineHeight: "18px" }}>¿Depositar en cuenta de imputación de débitos? SI / NO</Span>
                                        </HStack>
                                        <VStack mt={"20px"}>

                                            <Span mb={"8px"} color="primary.0" fontSize={"14px"} style={{ lineHeight: "18px" }}>
                                                CBU/CVU donde recibirá el reintegro
                                            </Span>
                                            {recibeEnCuentaOrigen ? (<input {...register('identificacionCuenta', { required: REQUIRED_FIELD, maxLength: getValues("nroCuentaDebitada").length, minLength: getValues("nroCuentaDebitada").length })}
                                                type="text" placeholder='CBU/CVU de destino' disabled={recibeEnCuentaOrigen} />
                                            )
                                                : (<input {...register('identificacionCuenta', { required: REQUIRED_FIELD, minLength: { value: 22, message: "Debe tener al menos 22 dígitos" }, pattern: { value: numberValidator, message: "El campo debe ser numérico" } })}
                                                    type="text" placeholder='CBU/CVU de destino' maxLength={22} />
                                                )}
                                            <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.identificacionCuenta ? "* " + errors.identificacionCuenta.message : ""}</Span>

                                        </VStack>
                                        <VStack mt={"20px"}>

                                            {fields.map((item, index) => (<>
                                                <VStack key={`informeIFE-${index}`} display={'flex'}>
                                                    <VStack id={`informeIFE-${index}`} justifyContent={'space-between'} display={'flex'} flexDirection={'row'}>
                                                        <VStack mr={"0.5rem"} mt={"20px"}>
                                                            <Span mb={"8px"} color="primary.0" fontSize={"14px"} style={{ lineHeight: "18px" }}>
                                                                Fecha del débito
                                                            </Span>
                                                            <VStack>


                                                                <input id={`fechaDebito-${item.id}`}
                                                                    {...register(`informeIFE.${index}.fechaDebito`, { required: REQUIRED_FIELD })}
                                                                    type="date" min={"2020-01-01"}
                                                                    max={"2020-12-31"}

                                                                />
                                                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.informeIFE && errors.informeIFE[index]?.fechaDebito ? "* " + errors.informeIFE[index]?.fechaDebito.message : ""}</Span>
                                                            </VStack>
                                                        </VStack>
                                                        <VStack mr={"0.5rem"} mt={"20px"}>
                                                            <Span mb={"8px"} color="primary.0" fontSize={"14px"} style={{ lineHeight: "18px" }}>
                                                                Concepto debitado
                                                            </Span>
                                                            <VStack>
                                                                <select id={`detalle-${item.id}`} tabIndex={0} aria-label={"Indique la gestión a realizar"}
                                                                    style={{ width: "100%" }}
                                                                    {...register(`informeIFE.${index}.detalle`, { required: REQUIRED_FIELD })}
                                                                    placeholder='Indique la gestión a realizar'
                                                                    onChange={(event) => { handleDetalleChange(event.target.value, `informeIFE.${index}.detalle`) }}>
                                                                    <option value="">Indique la gestión a realizar</option>
                                                                    <option value="0">Pago de tarjeta crédito</option>
                                                                    <option value="1">Débitos directos</option>
                                                                    <option value="2">Cuotas de préstamos</option>
                                                                    <option value="3">Impuestos</option>
                                                                    <option value="4">Comisiones</option>
                                                                    <option value="5">Otros</option>
                                                                </select>
                                                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.informeIFE && errors.informeIFE[index]?.detalle ? "* " + errors.informeIFE[index]?.detalle.message : ""}</Span>
                                                            </VStack>
                                                        </VStack>
                                                        <VStack mr={"0.5rem"} mt={"20px"}>
                                                            <Span mb={"8px"} color="primary.0" fontSize={"14px"} style={{ lineHeight: "18px" }}>
                                                                Importe debitado
                                                            </Span>


                                                            <CurrencyInput


                                                                decimalsLimit={2}
                                                                allowNegativeValue={false}
                                                                id={`importe-${item.id}`} {...register(`informeIFE.${index}.importe`, { required: REQUIRED_FIELD, minLength: { value: 2, message: "Debe tener al menos 2 dígitos" } })}
                                                                minLength={2} type="text" placeholder='Importe debitado'
                                                                name={'informeIFE.${index}.importe'}
                                                                onValueChange={(value) => handleImporteDebitoChange(value ? value : "", `informeIFE.${index}.importe`)}
                                                            />
                                                            <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.informeIFE && errors.informeIFE[index]?.importe ? "* " + errors.informeIFE[index]?.importe.message : ""}</Span>
                                                        </VStack>

                                                    </VStack>
                                                    <Button style={{ backgroundColor: '#cb3a3a', height: "calc(1.8em + 0.75rem + 2px)" }} id={`btn-${item.id}`} type="button" variant={'primary'} onClick={() => remove(index)} py={'10px !important'}>Eliminar</Button>
                                                </VStack>


                                            </>
                                            ))}
                                            <Button style={{ width: "fit-content", height: "calc(1.8em + 0.75rem + 2px)" }} id={`btn-+`} type="button" variant={'primary'} onClick={() => append({
                                                fechaDebito: null,
                                                detalle: undefined,
                                                importe: undefined

                                            })} py={'10px !important'} disabled={fields.length > 30}>Desea agregar otro concepto</Button>
                                        </VStack>
                                    </VStack>) : (<></>)

                            }


                            <Button type="submit" variant="secondary" marginBottom={"24px"} style={{ height: "calc(1.8em + 0.75rem + 2px)" }} py={'10px !important'}>Enviar</Button>
                        </>)

                    }

                </form>
            </VStack>

        </Box>

    )

};



export default DemandaColectivaIFEComponente;